import { createTheme } from '@mui/material/styles';

const adminTheme = createTheme({
    typography: {
        htmlFontSize: 10,
    },
});

export default adminTheme;
